<template>
  <b-modal
    v-model="showModal"
    title="Cập nhật trạng thái Megabiz"
    size="md"
    @hidden="onClose"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <div class="form-group">
      <label for="contractStatus" class="form-label">
        Chọn trạng thái <span class="text-danger">*</span>
      </label>
      <b-select
        id="contractStatus"
        v-model="selectedStatus"
        :options="statusOptions"
        text-field="name"
        value-field="code"
        class="form-control"
        :class="{ 'is-invalid': errors.status }"
      >
        <template #first>
          <b-select-option :value="null" disabled> -- Chọn trạng thái -- </b-select-option>
        </template>
      </b-select>
      <div v-if="errors.status" class="invalid-feedback">
        {{ errors.status }}
      </div>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end w-100">
        <b-button variant="secondary" class="mr-2" @click="onClose" :disabled="loading">
          Hủy
        </b-button>
        <b-button variant="primary" @click="onConfirm" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          {{ loading ? 'Đang xử lý...' : 'Xác nhận' }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { ContractService } from '@/services/contract.service'

  export default {
    name: 'UpdateStatusModal',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      contractId: {
        type: [String, Number],
        default: null,
      },
      defaultStatus: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        selectedStatus: null,
        loading: false,
        errors: {},
        statusOptions: [],
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      showModal: {
        get() {
          return this.visible
        },
        set(value) {
          this.$emit('update:visible', value)
        },
      },
    },
    watch: {
      visible(newVal) {
        if (newVal) {
          this.resetForm()
        }
      },
      selectedStatus() {
        if (this.errors.status) {
          this.errors = { ...this.errors, status: null }
        }
      },
      defaultStatus: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.selectedStatus = newVal
          }
        },
      },
    },
    methods: {
      async fetchData() {
        try {
          this.loading = true
          const data = await ContractService.getListStatusMegabiz({})
          if (data.success) {
            const list = data.data.contractStt || []
            this.statusOptions = list.map(e => ({
              code: e.code,
              name: e.name,
              ...e,
            }))
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      resetForm() {
        this.selectedStatus = this.defaultStatus || null
        this.errors = {}
        this.loading = false
      },

      validateForm() {
        this.errors = {}

        if (!this.selectedStatus) {
          this.errors.status = 'Vui lòng chọn trạng thái'
        }

        return Object.keys(this.errors).length === 0
      },

      async onConfirm() {
        if (!this.validateForm()) {
          return
        }

        try {
          this.loading = true

          const payload = {
            contractId: this.contractId,
            megabizStt: this.selectedStatus,
          }

          // Gọi API cập nhật trạng thái
          const response = await ContractService.updateMegabozStatus(payload)

          if (response.code === 1000) {
            this.$emit('success', {
              status: this.selectedStatus,
              message: 'Cập nhật trạng thái thành công',
            })
            this.onClose()
          } else {
            throw new Error(response?.message || 'Có lỗi xảy ra')
          }
        } catch (error) {
          console.error('Error updating status:', error)
          this.$emit('error', {
            message: error.message || 'Cập nhật trạng thái thất bại',
          })
        } finally {
          this.loading = false
        }
      },

      onClose() {
        // if (!this.loading) {
        this.showModal = false
        this.$emit('close')
        // }
      },
    },
  }
</script>

<style scoped>
  .form-label {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .is-invalid {
    border-color: #dc3545;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
  }

  .text-danger {
    color: #dc3545 !important;
  }
</style>
